import { getSiteBrand } from "@/lib/siteHosts";

const brandName = () => getSiteBrand().name;

export const CHANNELS_STAMP = "OMNICHANNEL";
export const CHANNELS_TAG = "8 channels · 1 brain";
export const CHANNELS_SCAN_LINE = "Same voice · Same speed · Zero missed threads";

export const CHANNELS_HEADLINE = {
  lead: "Your Digital Employee Responds",
  accent: "Across 8 Channels",
};

export const CHANNELS = [
  {
    id: "widget",
    get name() {
      return `${brandName()} Widget`;
    },
    tag: "On-site capture",
    highlight: false,
  },
  { id: "ghl", name: "GHL", tag: "Native sync" },
  { id: "sms", name: "SMS", tag: "Instant reply" },
  { id: "email", name: "Email", tag: "Auto-reply" },
  { id: "instagram", name: "Instagram", tag: "DM replies" },
  { id: "facebook", name: "Facebook", tag: "Messenger" },
  { id: "whatsapp", name: "WhatsApp", tag: "Global reach" },
  { id: "telegram", name: "Telegram", tag: "Async chat" },
];

export const CHANNELS_WORKFLOW = [
  { step: "MESSAGE", text: "Lead texts on any channel" },
  { step: "REPLY", text: "Employee responds in 26 seconds" },
  { step: "LOGGED", text: "Synced straight to your CRM" },
];

export const CHANNELS_PAYOFF =
  "Widget · GHL · SMS · Email · Instagram · Facebook · WhatsApp · Telegram";
